import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import { useSoFormStepsState } from '../../SoForm.context';
import SoFormContainer from '../../components/layout/SoFormContainer';
import { WarningIcon } from 'refactored/ui/icons';
import { useTranslation } from 'react-i18next';

const TempContainer = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;

const SoFormStepPriceZipCodeInfo = ({ className }) => {
  const stepsState = useSoFormStepsState();
  const isZipcode = stepsState.configuration.isZipcode;
  const showZipCodeError = stepsState.price.showZipcodeError;

  const finalClassName = `${className} ${showZipCodeError ? 'infoError' : ''}`;
  const { t } = useTranslation('Catalog');

  if (!isZipcode) return <></>;

  return (
    <div className={finalClassName}>
      <SoFormContainer>
        <TempContainer>
          <WarningIcon />
          {t('price.go_to_previus_step')}
        </TempContainer>
      </SoFormContainer>
    </div>
  );
};

SoFormStepPriceZipCodeInfo.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepPriceZipCodeInfo)`
  border-bottom: 4px solid var(--primary300);
  background: white;
  width: 100%;
  margin-top: auto;
  text-align: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding: 12px 16px;
  padding-top: 0;
  color: #263340;
  /* Inside auto layout */

  text-align: center;

  svg {
    fill: var(--primary300);
    path {
      fill: var(--primary300);
    }
  }

  &.infoError {
    border-bottom: 4px solid var(--error700);
    svg {
      fill: var(--error700);
      path {
        fill: var(--error700);
      }
    }
  }
`;
